/**
 * Arayüzde TEK tarih biçimi (K-M7-50.5, v3.1 A7). Ürün turunda aynı bilgi bazı ekranlarda "8 Eki 2026", bazılarında
 * "8.10.2026" ya da "08.10.2026" görünüyordu. Karar: liste kolonlarıyla aynı sayısal biçim —
 *  - takvim günü: GG.AA.YYYY (`08.10.2026`)
 *  - an (tarih-saat): GG.AA.YYYY SS:dd (`08.10.2026 14:30`; 24 saat), saniye yalnız teknik kayıtlarda (`seconds`).
 * Saat dilimi verilmezse tarayıcının saat dilimi kullanılır; çalışma alanı saat dilimi gereken yerde çağıran verir.
 */
const cache = new Map<string, Intl.DateTimeFormat>();

function fmt(timeZone: string | undefined, time: boolean, seconds: boolean): Intl.DateTimeFormat {
  const key = `${timeZone ?? ''}|${String(time)}|${String(seconds)}`;
  let f = cache.get(key);
  if (f === undefined) {
    f = new Intl.DateTimeFormat('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      ...(time ? { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' as const } : {}),
      ...(time && seconds ? { second: '2-digit' } : {}),
      ...(timeZone ? { timeZone } : {}),
    });
    cache.set(key, f);
  }
  return f;
}

function toDate(v: string | Date): Date | null {
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** An → `08.10.2026 14:30` (geçersiz değer olduğu gibi döner) */
export function formatDateTimeTr(
  v: string | Date,
  opts: { timeZone?: string | undefined; seconds?: boolean } = {},
): string {
  const d = toDate(v);
  if (d === null) return typeof v === 'string' ? v : '';
  return fmt(opts.timeZone, true, opts.seconds === true).format(d);
}

/** Anın takvim günü → `08.10.2026` */
export function formatDateTr(v: string | Date, timeZone?: string): string {
  const d = toDate(v);
  if (d === null) return typeof v === 'string' ? v : '';
  return fmt(timeZone, false, false).format(d);
}

/**
 * Bir anın verilen IANA saat dilimindeki takvim günü (`YYYY-MM-DD`; tarih girdisi ve sorgu parametresi biçimi). Çalışma alanı
 * saat diliminde "bugün" gerektiren varsayılanlar (rapor aralıkları) tarayıcının yerel tarihini DEĞİL bunu kullanır.
 */
export function calendarDateIn(timeZone: string, at: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(at);
  const part = (t: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === t)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}

/** `YYYY-MM-DD` takvim gününe gün ekler (takvim aritmetiği; saat dilimi ve yaz saati etkisizdir) */
export function addCalendarDays(isoDate: string, days: number): string {
  const [y = 1970, m = 1, d = 1] = isoDate.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}
